module.exports = __webpack_public_path__ + "static/img/icon_create.2dd979d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common-icons/icon_create.svg
// module id = IF6t
// module chunks = 1